import './SkipLinks.scss';

export const SkipLinks = ({
  onClickFocusContent,
  onClickFocusMenu,
}) => {

  const SKIP_LINKS = [
    {
      id: 1,
      label: 'Przejdź do menu',
      onClick: onClickFocusMenu,
    },
    {
      id: 2,
      label: 'Przejdź do treści',
      onClick: onClickFocusContent,
    },
  ];

  return (
    <nav className="skip-links-container" aria-labelledby="skipLinksNav">
      <h2 className="sr-only" id="skipLinksNav">Nawigacja pomocnicza</h2>
      <ul className="skip-links-list">
        {[...SKIP_LINKS].map((link) =>
          link.onClick && (
            <li key={link.id}>
              <button
                component="button"
                onClick={link.onClick}
                className="skip-link"
                tabIndex={link.id}
              >
                {link.label}
              </button>
            </li>
          )
        )}
      </ul>
    </nav>
  )
};
